// extracted by mini-css-extract-plugin
module.exports = {"container":"FreelancersFeed_container__1klsX","pagination":"FreelancersFeed_pagination__2mpld"};